import React, { useState } from 'react'
import SimRadioButton from '../RadioButton'
import { useDispatch, useSelector } from 'react-redux';
import { setNewsletter, setReminder } from '../../Store/slice/subscriptionSlice';

const ExpiryAlerts = () => {
    const dispatch = useDispatch();
    const { reminder, newsletter } = useSelector(state => state.subscriptionSlice);

    return (
        <>
            <div className="colorborder" style={{ height: 'auto' }}>
                <div className="expiry-alerts">
                    <h5>Alerts</h5>
                    <p>Select the time for reminding an organization about an expired subscription</p>

                    <div className="plantype mt-4">
                        <div className='org-validity'>
                            <p>Reminder in</p>
                            <div className='validity-time mt-2'>
                                <SimRadioButton label="30 Days" id='thirtydays' name="reminder" onChange={() => dispatch(setReminder({ data: 30 }))} checked={reminder === 30} />
                                <SimRadioButton label="15 Days" id='fifteendays' name="reminder" onChange={() => dispatch(setReminder({ data: 15 }))} checked={reminder === 15} />
                                <SimRadioButton label="07 Days" id='sevendays' name="reminder" onChange={() => dispatch(setReminder({ data: 7 }))} checked={reminder === 7} />
                            </div>
                        </div>
                    </div>
                    <div className="plantype mt-4">
                        <div className='org-validity'>
                            <p className='m-0'>Subscribe Newsletter</p>
                            <div className='validity-time mt-2'>
                                <SimRadioButton label="Yes" id='yes' name="newsletter" onChange={() => dispatch(setNewsletter({ data: true }))} checked={newsletter === true} />
                                <SimRadioButton label="No" id='no' name="newsletter" onChange={() => dispatch(setNewsletter({ data: false }))} checked={newsletter === false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ExpiryAlerts
